import React from "react";
import { AgGridReact } from "ag-grid-react";
import { Skeleton } from "@mui/material";
import "@mui/icons-material/QueryBuilder";
import useTitanApp from "../../hooks/useTitanApp";
function DrugSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  return (
    <div className="view-prescription-content">
      <div className="view-prescription-wrapper">
        <div className="view-prescription-content-wrapper" style={{ gap: "20px" }}>
          <div className="prescription-left-panel">
            <div className="d-flex">
              <Skeleton
                animation="wave"
                width={"100%"}
                sx={{ bgcolor: darkMode ? "grey.800" : "", height: 50 }}
              />
            </div>
            <Skeleton
              animation="wave"
              width={"100%"}
              sx={{ bgcolor: darkMode ? "grey.800" : "", height: 50 }}
            />
            <Skeleton
              animation="wave"
              width={"100%"}
              sx={{ bgcolor: darkMode ? "grey.800" : "", height: 50 }}
            />
            <div className="d-flex">
              <Skeleton
                animation="wave"
                width={"100%"}
                sx={{ bgcolor: darkMode ? "grey.800" : "", height: 90 }}
              />
            </div>

          </div>
          <div className="prescription-right-panel">
            <div className="info-boxes" >
              <div className="d-flex">
                <Skeleton
                  animation="wave"
                  width={"100%"}
                  sx={{ bgcolor: darkMode ? "grey.800" : "", height: 150 }}
                />
              </div>
              <div className="d-flex">
                <Skeleton
                  animation="wave"
                  width={"100%"}
                  sx={{ bgcolor: darkMode ? "grey.800" : "", height: 150 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default DrugSkeleton;
